export default __webpack_public_path__ + "static/media/eternity.c91c554a.jpg";